import { useEffect } from 'react';
import EcosystemGrid from '@/components/EcosystemGrid';
import MarketCTA from '@/components/MarketCTA';

export default function EcosystemPage() {
  useEffect(() => {
    document.title = 'THE TOONVERSE ECOSYSTEM — ARC TOONS';
  }, []);

  return (
    <>
      <EcosystemGrid />
      <MarketCTA />
    </>
  );
}
